import React, {useEffect, useMemo, useState} from "react";
import {GlobalLayoutPropsInterface, MMP_FORM} from "../../types";
import {RouteComponentProps, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {RootStore} from "../../configureStore";
import useBasePage from "../../hooks/useBasePage";
import * as actions from "../RegistrationLoginPage/actions";
import {usePageDataHook, useTrackingHook} from "../../hooks/utility";
import config from "../../config/config";
import {setReferrerAndPageType} from "../../components/Layout/actions";
import {clearRegistrationAndReferralRedux} from "../../components/CTA/response";
import {isUserLoggedIn, pageTrackingData} from "../../utils/utils";
import {
    ABROAD_SIGN_UP_PROP_MAP,
    IELTS_EXAM_MMP_ID,
    MMP_PAGE_NAME,
    TOEFL_EXAM_MMP_ID,
} from "../RegistrationLoginPage/utils";
import {PageTrackingData} from "../../components/CTA/types";
import RegistrationLogin from "../../components/RegistrationLogin";

const BYS_DIGILOCKER_V3_TRIGGER_CTA = "bysDigilockerV3";
const BYS_DIGILOCKER_V3_TKEY = 15706;

interface Props extends RouteComponentProps {
    globalLayoutProps: GlobalLayoutPropsInterface;
}

const isChatBotEligible = (mmpId: string) => {
    const chatBotMMP = [
        "7445",
        "7447",
        "7170",
        "7483",
        "7495",
        "7497",
        "7499",
        "7510",
        "7563",
        "7584",
        "7788",
        "7790",
        "7792",
        "7395",
        "7826",
        "7824",
        "7822",
        "7820",
        "7818",
        "7816",
        "7814",
        "7794",
        "7834",
        "7836",
        "7838",
        "7840",
        "7842",
        "7245",
        "7399",
        "7315",
        "8579",
        "8577",
    ];
    if (chatBotMMP.includes(mmpId)) {
        return true;
    }
    return true;
};

const MultiMarketingPage: React.FC<Props> = (props: Props) => {
    const dispatch = useDispatch();
    const {mmpId}: {mmpId: string} = useParams();
    const isInternationalUser = useSelector(
        (state: RootStore) => state.layout?.isInternationalUser,
    );
    const showChatBot = !isInternationalUser && isChatBotEligible(mmpId);
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const isLoggedIn = useSelector(
        (state: RootStore) => state.layout.userAndShortlistData?.userLoggedIn ?? false,
    );
    const ctaTrackingData = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.ctaTrackingData,
    );

    const userType = useSelector(
        (state: RootStore) => state.layout.userAndShortlistData?.userBasicDetail?.type,
    );
    const displayName = useSelector(
        (state: RootStore) => state.layout.userAndShortlistData?.userBasicDetail?.displayName,
    );

    useEffect(() => {
        if (showChatBot) {
            if (userType !== "t3_sa" || mmpId == IELTS_EXAM_MMP_ID || mmpId == TOEFL_EXAM_MMP_ID) {
                let trackingKey = (pageTrackingData(
                    isMobile,
                    ABROAD_SIGN_UP_PROP_MAP,
                    MMP_PAGE_NAME,
                    "defaultTrackingID",
                ) as PageTrackingData).defaultTrackingID.trackingId;
                if (mmpId == IELTS_EXAM_MMP_ID) {
                    trackingKey = (pageTrackingData(
                        isMobile,
                        ABROAD_SIGN_UP_PROP_MAP,
                        MMP_PAGE_NAME,
                        "ieltsExamMmpId",
                    ) as PageTrackingData).ieltsExamMmpId.trackingId;
                }
                if (mmpId == TOEFL_EXAM_MMP_ID) {
                    trackingKey = (pageTrackingData(
                        isMobile,
                        ABROAD_SIGN_UP_PROP_MAP,
                        MMP_PAGE_NAME,
                        "toeflExamMmpId",
                    ) as PageTrackingData).toeflExamMmpId.trackingId;
                }
                // const trackingKey = (pageTrackingData(
                //     isMobile,
                //     ABROAD_SIGN_UP_PROP_MAP,
                //     MMP_PAGE_NAME,
                //     "defaultTrackingID",
                // ) as PageTrackingData).defaultTrackingID.trackingId;
                if (typeof window.ChatbotLoader === "function") {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    window.openChatBotRegistration1 = new window.ChatbotLoader(config.SHIKSHA_HOME);
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const trackIeltsExamMmp = mmpId == IELTS_EXAM_MMP_ID ? true : false;
                    // exam MMPs keep convMMP's own redirect to their configured destination
                    const isExamMmp = mmpId == IELTS_EXAM_MMP_ID || mmpId == TOEFL_EXAM_MMP_ID;
                    window.openChatBotRegistration1.openChatBotRegistration(
                        {
                            mmpPageId: mmpId,
                            appId: 5,
                            trackingKeyId: trackingKey,
                            trackIeltsExamMmp: trackIeltsExamMmp,
                            // convMMP calls this on completion for a logged-in user; without it handleFinish throws
                            afterLoginAction: () => undefined,
                        },
                        isExamMmp
                            ? undefined
                            : (responseData) => {
                                  if (responseData?.status === "SUCCESS") {
                                      // self serve layer opens (and fires its tracking) off triggerCta on /apply
                                      window.location.href = `${config.SHIKSHA_STUDYABROAD_HOME}/apply?triggerCta=${BYS_DIGILOCKER_V3_TRIGGER_CTA}&tkey=${BYS_DIGILOCKER_V3_TKEY}`;
                                  }
                              },
                    );
                }
            } else {
                //redirect to edit profile page
                window.location.href = displayName
                    ? `${config.SHIKSHA_STUDYABROAD_HOME}/users/${displayName}/edit`
                    : config.SHIKSHA_STUDYABROAD_HOME;
            }
        }
    }, [isMobile, mmpId, userType, displayName, showChatBot]);

    useEffect(() => {
        if (!ctaTrackingData && !showChatBot) {
            const trackingKey = (pageTrackingData(
                isMobile,
                ABROAD_SIGN_UP_PROP_MAP,
                MMP_PAGE_NAME,
                "defaultTrackingID",
            ) as PageTrackingData).defaultTrackingID.trackingId;

            dispatch(
                actions.setTrackingDataAction(
                    {
                        trackingId: trackingKey,
                        ctaType: MMP_FORM,
                        mmpId: parseInt(mmpId),
                    },
                    MMP_FORM,
                ),
            );
        }
    }, [isMobile, mmpId, dispatch, ctaTrackingData, showChatBot]);

    const [showContentLoader, setContentLoaderStatus] = useState(false);

    const signUpPageData = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.signUpPageData,
    );

    const {location, globalLayoutProps} = props;
    useBasePage(location, globalLayoutProps);

    const pageDataHookObj = {
        reduxBucketName: globalLayoutProps.reduxBucketName,
        pageData: signUpPageData,
        setContentLoaderStatus,
        location,
        api: actions.fetchInitialData,
        actions,
        startFromTop: true,
    };
    usePageDataHook(pageDataHookObj);

    useTrackingHook({
        pageName: globalLayoutProps.pageName,
        pageData: signUpPageData,
        isLoaderActive: showContentLoader,
    });

    useEffect(() => {
        return () => {
            clearRegistrationAndReferralRedux({
                dispatch,
                ignoreMMPTrackingData: true,
            });
        };
    }, [dispatch]);

    useEffect(() => {
        dispatch(
            setReferrerAndPageType({
                referrerURL: config.SHIKSHA_STUDYABROAD_HOME,
                isReferrerPWA: false,
            }),
        );
    }, [dispatch]);

    return useMemo(() => {
        return showChatBot ? (
            <p></p>
        ) : (
            <RegistrationLogin
                signUpPageData={signUpPageData}
                showLogin={isClientEnv ? !isUserLoggedIn() : !isLoggedIn}
                showSignUp={true}
                showContentLoader={showContentLoader}
            />
        );
    }, [signUpPageData, showContentLoader, isLoggedIn, showChatBot]);
};

export default MultiMarketingPage;
